<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Company Owner Information</h6>
            <!-- {{-- for sole Proprietorship --}} -->
            <div v-if="isProprietorship" class="row">
                <div class="col-lg-4 col-sm-12">
                    <form-input placeholder="Last Name" label="Last Name" v-model="form.owner_lastname" ref="owner_lastname"></form-input>
                </div>
                <div class="col-lg-5 col-sm-12">
                    <form-input placeholder="First Name" label="First Name" v-model="form.owner_firstname" ref="owner_firstname"></form-input>
                </div>
                <div class="col-lg-3 col-sm-12">
                    <form-input placeholder="Middle Name" label="Middle Name" v-model="form.owner_middlename" ref="owner_middlename" show-optional-label optional-label="(Optional)"></form-input>
                </div>
            </div>
            
            <!-- {{-- for Corporation --}} -->
            <div v-else class="row">
                <div class="col-lg-10 col-sm-12">
                    <form-input placeholder="Principal/s" label="Principal/s" v-model="form.principals" ref="principals"></form-input>
                </div>
            </div>

            <h6 class="heading-small text-muted">Company Business Information</h6>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <form-date-picker
                        format="MMMM DD, YYYY"
                        label="Date Established"
                        placeholder="Date Established"
                        v-model="form.date_established"
                        max-date="today"
                        ref="date_established"
                    ></form-date-picker>
                </div>
                <div class="col-md-4 col-sm-12">
                    <form-select :options="selectOptions.employeeCount" label="Total no. of employees" placeholder="Total no. of employees" v-model="form.employee_count" ref="employee_count"></form-select>
                </div>

                <div class="col-md-6 col-sm-12">
                    <form-input label="No. of branches in Metro Manila" placeholder="No. of branches in Metro Manila" show-optional-label optional-label="(Company owned)" v-model="form.metropolitant_branch_count" ref="metropolitant_branch_count"></form-input>  
                </div>
                <div class="col-md-6 col-sm-12">
                    <form-input label="No. of branches in Provicial Areas" placeholder="No. of branches in Provicial Areas" show-optional-label optional-label="(Company owned)" v-model="form.provincial_branch_count" ref="provincial_branch_count"></form-input>
                </div>

                <div class="col-md-6 col-sm-12">
                    <form-input label="No. of branches in Metro Manila" placeholder="No. of branches in Metro Manila" show-optional-label optional-label="(Franchised)" v-model="form.franchised_metropolitant_branch_count" ref="franchised_metropolitant_branch_count"></form-input>
                </div>
                <div class="col-md-6 col-sm-12">
                    <form-input label="No. of branches in Provicial Areas" placeholder="No. of branches in Provicial Areas" show-optional-label optional-label="(Franchised)" v-model="form.franchised_provincial_branch_count" ref="franchised_provincial_branch_count"></form-input>
                </div>

                
                <div class="col-sm-12 pb-4">
                    <checkbox v-model="form.register_all_branches" class="inline-block"></checkbox>
                    <div class="inline-block">Are you willing to register all your branches?</div>
                </div>

                <div v-if="!form.register_all_branches" class="col-sm-12 pb-4">
                    <form-input label="How many branches are you willing to register" placeholder="No. of branches" ref="register_branches_count" v-model="form.register_branches_count"></form-input>
                </div>
                
                <div class="col-sm-12 pb-4">
                    <checkbox class="inline-block" v-model="form.has_booking_system"></checkbox>
                    <div class="inline-block">Do you currently have an online booking system?</div>
                </div>
                <div v-if="form.has_booking_system" class="col-sm-12">
                    <!-- {{-- if yes --}} -->
                    <form-input label="For how long?" placeholder="" v-model="form.duration_of_booking_system_use" ref="duration_of_booking_system_use"></form-input>
                </div>
                <div v-if="form.has_booking_system" class="col-sm-12 pb-4">
                    <!-- {{-- if yes --}} -->
                    <form-input label="Specify online booking system used" type="textarea" :rows="3" v-model="form.booking_system_remark" ref="booking_system_remark"></form-input>
                </div>

                <div class="col-sm-12">
                    <form-input label="Services offered in shop" type="textarea" :rows="4" v-model="form.serivces_offered" ref="serivces_offered"></form-input>
                </div>

                <div class="col-md-4 col-sm-12">
                    <form-input label="BIR Certificate of Registration" placeholder="BIR Certificate of Registration" type="file" accept=".jpeg,.png,.pdf" ref="certificate_of_registration"
                        @change="(value) => changeFileValue('certificate_of_registration', value)"></form-input>
                </div>
                <div class="col-md-4 col-sm-12">
                    <form-input label="Business Permit" placeholder="Business Permit" type="file" accept=".jpeg,.png,.pdf" ref="business_permit"
                        @change="(value) => changeFileValue('business_permit', value)"></form-input>
                </div>
                <div class="col-md-4 col-sm-12">
                    <form-input label="Owner's ID" placeholder="Owner's ID" show-optional-label optional-label="(Goverment Issued)" type="file" accept=".jpeg,.png,.pdf" ref="owner_id"
                        @change="(value) => changeFileValue('owner_id', value)"></form-input>
                </div>

            </div>

            <div class="row">
                <div class="col-sm-12">
                    <button v-if="!isRequesting" class="btn float-left" @click="back">
                        <i class="fas fa-angle-left mr-2"></i> Back
                    </button>
                    <button v-else class="btn float-left" disabled>
                        <i class="fas fa-angle-left mr-2"></i> Back
                    </button>

                    <button v-if="!isRequesting" class="btn btn-warning float-right" @click="next">
                        Next <i class="fas fa-angle-right ml-2"></i>
                    </button>
                    <button v-else class="btn btn-warning float-right" disabled>
                        <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                    </button>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import moment from "moment";
import mixins from "@utils/mixins";
import { validateBusinessInfo } from "../helpers";
import options from "./options";

export default {
    name: "BusinessInfoSection",

    computed: {
        parentFormData() {
            return this.$parent.$parent.data || {};
        },
        isProprietorship() {
            return this.businessType == "sole_proprietorship";
        },
        isOwner() {
            return this.parentFormData.is_owner;
        },
        registerAllBranches() {
            return this.form.register_all_branches;
        },
        hasBookingSystem() {
            return this.form.has_booking_system;
        },
    },

    data: () => ({
        selectOptions: options,
        isRequesting: false,
        form: {
            owner_lastname: "",
            owner_firstname: "",
            owner_middlename: "",
            principals: "",
            date_established: moment().format("MMMM DD, YYYY"),
            employee_count: "",
            metropolitant_branch_count: "",
            provincial_branch_count: "",
            franchised_metropolitant_branch_count: "",
            franchised_provincial_branch_count: "",
            register_all_branches: false,
            register_branches_count: "",
            has_booking_system: false,
            duration_of_booking_system_use: "",
            booking_system_remark: "",
            serivces_offered: "",
            certificate_of_registration: null,
            business_permit: null,
            owner_id: null,
        },
    }),
    methods: {
        initialize() {
            this.isRequesting = false;
            this.form = {
                employee_count: this.parentFormData.employee_count || "",
                metropolitant_branch_count: this.parentFormData.metropolitant_branch_count || "",
                provincial_branch_count: this.parentFormData.provincial_branch_count || "",
                franchised_metropolitant_branch_count: this.parentFormData.franchised_metropolitant_branch_count || "",
                franchised_provincial_branch_count: this.parentFormData.franchised_provincial_branch_count || "",
                register_all_branches: this.parentFormData.register_all_branches || false,
                register_branches_count: this.parentFormData.register_branches_count || "",
                has_booking_system: this.parentFormData.has_booking_system || false,
                duration_of_booking_system_use: this.parentFormData.duration_of_booking_system_use || "",
                booking_system_remark: this.parentFormData.booking_system_remark || "",
                serivces_offered: this.parentFormData.serivces_offered || "",
                certificate_of_registration: this.parentFormData.certificate_of_registration || null,
                business_permit: this.parentFormData.business_permit || null,
                owner_id: this.parentFormData.owner_id || null,
            }

            if (this.isOwner) {
                this.form.owner_firstname = this.parentFormData.firstname;
                this.form.owner_middlename = this.parentFormData.middlename;
                this.form.owner_lastname = this.parentFormData.lastname;
            } else {
                this.form.principals = this.parentFormData.principals;
            }
        },
        changeFileValue(key, file) {
            let reader = new FileReader();
            reader.onload = (e) => setTimeout(() => this.form[key] = e.target.result, 500);
            reader.readAsDataURL(file);
        },
        back() {
            this.$emit("back");
        },
        next() {
            this.isRequesting = true;
            validateBusinessInfo(this.businessType, this.form)
                .then(response => this.$emit("next", {...this.form}))
                .catch(error => {
                    console.log(error);
                    this.promptFormErrors(this.$refs, error)
                })
                .finally(() => this.isRequesting = false);
        },
    },

    watch: {
        registerAllBranches(newValue) {
            this.form.register_branches_count = newValue ? null : 0;
        },
        hasBookingSystem(newValue) {
            if (newValue) return;

            this.form.duration_of_booking_system_use = null;
            this.form.booking_system_remark = null;
        },
    },

    mixins: [mixins],

    props: {
        businessType: String,
    },

    mounted() {
        this.initialize();
    }
}
</script>